export const IndicatorId = ({ value, record }) => record.result?.indicatorId;
